// Helpers shared between coach + member schedule UIs.

export const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const DAY_LABELS_LONG = [
    "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday",
];

// Build the list of HH:MM half-hour start times from 05:00 → 22:00.
export const HALF_HOUR_TIMES = (() => {
    const out = [];
    for (let h = 5; h <= 22; h++) {
        out.push(`${String(h).padStart(2, "0")}:00`);
        if (h < 22) out.push(`${String(h).padStart(2, "0")}:30`);
    }
    return out;
})();

export function formatTimeDisplay(hhmm) {
    const [h, m] = hhmm.split(":").map(Number);
    const period = h >= 12 ? "PM" : "AM";
    const hr12 = ((h + 11) % 12) + 1;
    return `${hr12}:${String(m).padStart(2, "0")} ${period}`;
}

export function isoDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

// Monday of the week containing `d` (local time).
export function startOfWeekMon(d) {
    const day = d.getDay(); // 0=Sun..6=Sat
    const diff = (day === 0 ? -6 : 1 - day);
    const out = new Date(d.getFullYear(), d.getMonth(), d.getDate() + diff);
    return out;
}

export function addDays(d, n) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
}

export function weekRangeLabel(monday) {
    const sunday = addDays(monday, 6);
    const opts = { month: "short", day: "numeric" };
    const a = monday.toLocaleDateString(undefined, opts);
    const b = sunday.toLocaleDateString(
        undefined,
        monday.getFullYear() === sunday.getFullYear() ? opts : { ...opts, year: "numeric" }
    );
    return `${a} – ${b}`;
}

// JS Date.getDay returns 0=Sun..6=Sat; we use 0=Mon..6=Sun.
export function jsDayToMonIdx(d) {
    return (d + 6) % 7;
}
